import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Radio,
  FormControlLabel,
  RadioGroup,
  CircularProgress,
  IconButton
} from '@mui/material';
import { Search } from 'lucide-react';
import CustomSnackbar from './CustomSnackbar';
import { isTestEnv } from "../globals";
import useAddCustomer from './AddCustomerHook';
import translation from '../translations/orderFormTranslation';

const AddCustomerForm = ({ setCustomers, customers, setMockDropdownData }) => {
  const {
    open, setOpen,
    customerName, setCustomerName,
    customerDes, setCustomerDes,
    customerType, setCustomerType,
    isOrderingCustomer, setIsOrderingCustomer,
    isReceivingCustomer, setIsReceivingCustomer,
    snackbar, setSnackbar,
    handleCancel,
    translations,
    fetchCustomerDetails,
    isLoading,
    handleSubmit,
    isFormValid
  } = useAddCustomer(customers, setCustomers, setMockDropdownData);

  return (
    <div dir='rtl'>
      <Button variant="contained" onClick={() => setOpen(true) } sx={{ justifyContent: 'center', display: 'flex', marginLeft: 'auto' }}>
        {translations.addCustomer}
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{translations.addNewCustomer}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {translations.fillCustomerDetails}
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label={translations.customerNumber}
            type="text"
            fullWidth
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            required
            InputProps={{
              endAdornment: (
                <IconButton onClick={fetchCustomerDetails} disabled={!customerName || isLoading}>
                  {isLoading ? <CircularProgress size={20} /> : <Search />}
                </IconButton>
              ),
            }}
          />
          <TextField
            margin="dense"
            label={translations.customerName}
            type="text"
            fullWidth
            value={customerDes}
            onChange={(e) => setCustomerDes(e.target.value)}
            disabled
            required
          />
          <RadioGroup
            aria-label="customerType"
            name="customerType"
            value={customerType}
            onChange={(e) => setCustomerType(e.target.value)}
          >
            <FormControlLabel value={translation.internal} control={<Radio />} label={translations.internal} />
            <FormControlLabel value={translation.external} control={<Radio />} label={translations.external} />
          </RadioGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={isOrderingCustomer}
                onChange={(e) => setIsOrderingCustomer(e.target.checked)}
              />
            }
            label={translations.orderingCustomer}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isReceivingCustomer}
                onChange={(e) => setIsReceivingCustomer(e.target.checked)}
              />
            }
            label={translations.receivingCustomer}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="secondary">
            {translations.cancel}
          </Button>
          <Button onClick={handleSubmit} color="primary" disabled={!isFormValid}>
            {translations.add}
          </Button>
        </DialogActions>
      </Dialog>
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </div>
  );
};

export default AddCustomerForm;